import React, { createContext, useContext, useState, useEffect } from 'react'
import { API_ENDPOINTS } from '../utils/config.jsx'
import { authAPI } from '../services/api.jsx'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(localStorage.getItem('admin_token'))

  // Note: Authentication headers are handled by the api instance in api.jsx
  // No need to set global axios defaults

  // Check authentication status on mount
  useEffect(() => {
    if (token) {
      setIsAuthenticated(true)
    }
    setLoading(false)
  }, [token])

  const login = async ({ email, password } = {}) => {
    try {
      if (!email || !password) {
        return { success: false, message: 'Email and password required' }
      }
      const res = await authAPI.login(email, password)
      if (!res.success || !res.token) {
        return { success: false, message: res.error?.message || 'Invalid credentials' }
      }
      localStorage.setItem('admin_token', res.token)
      setToken(res.token)
      setIsAuthenticated(true)
      
      // Handle redirect after login
      const redirectPath = sessionStorage.getItem('redirectAfterLogin')
      if (redirectPath && redirectPath !== '/login') {
        sessionStorage.removeItem('redirectAfterLogin')
        window.location.href = redirectPath
      } else {
        window.location.href = '/'
      }
      
      return { success: true }
    } catch (error) {
      return { success: false, message: 'Login failed' }
    }
  }

  const logout = () => {
    setToken(null)
    setIsAuthenticated(false)
    localStorage.removeItem('admin_token')
  }

  const value = {
    isAuthenticated,
    loading,
    login,
    logout,
    token
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
